import usePhoneClosure from '@/hooks/usePhoneClosure';

export default function PhoneHours({ en = false, children }) {
  const closed = usePhoneClosure();
  return closed ? (en ? 'Phone lines closed today (30 October).' : 'Telefonerne er lukket i dag (30. oktober).') : children;
}